import { useTranslation } from 'react-i18next'
import { useConnectionStatus } from '../../hooks/useConnectionStatus'

const COLOR_MAP = {
  open: '#22c55e',
  connecting: '#f97316',
  error: '#ef4444',
  idle: 'transparent',
} as const

export function ConnectionStatusDot() {
  const { t } = useTranslation('dashboard')
  const { status, reconnectCount } = useConnectionStatus()

  if (status === 'idle') return null

  const ariaLabelMap = {
    open: t('connection.open'),
    connecting: t('connection.connecting'),
    error: t('connection.error'),
    idle: '',
  } as const

  return (
    <span
      data-testid="connection-status-dot"
      aria-label={ariaLabelMap[status]}
      title={t('connection.title', { count: reconnectCount })}
      style={{
        display: 'inline-block',
        width: 10,
        height: 10,
        borderRadius: '50%',
        background: COLOR_MAP[status],
        flexShrink: 0,
      }}
    />
  )
}
